import React from 'react'

const NoData = () => {
  return (
    <div style={{background:'#fff',height:'160px',}}>
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',fontSize:'14px', padding:'60px',fontWeight:600,fontFamily:'Segoe UI'}}>
            <span>No data available</span>
        </div>
    </div>
  )
}

export default NoData